export default "__VITE_ASSET__Buo1kB$J__"